module.exports = __webpack_public_path__ + "h5/img/funv-title3.13368ef3.png";